import React from "react";

function ErrorPage() {
  return (
    <div id="div-404">
      <h1>ERROR 404 </h1>
      <img id="sorry-img" src="../../images/sorry.svg" alt="location"></img>
    </div>
  );
}

export default ErrorPage;
